define.alias("shared/components/shared/profile-avatar", "media/components/shared/profile-avatar");